import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CheckUnsavedForms } from '../interfaces/check-unsaved-forms';

@Injectable({
  providedIn: 'root'
})
export class UnsavedFormGuard  {
  canDeactivate(
    component: CheckUnsavedForms,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.hasUnsavedForms && component.hasUnsavedForms()) {
      return component.showNavigationAlert();
    }
    return true;
  }
}
